// extracted by mini-css-extract-plugin
export default {"hide":"SectionsACAREA_hide__rC7NG","initial":"SectionsACAREA_initial__1iIa6","expanded":"SectionsACAREA_expanded__UkatX"};